<template>
    <section class="content report-payout-list">
      <div v-if="source !== 'payout'">
        <div class="sub-title">Submitted Payouts</div>
        <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:10px;" />
      </div>
      <v-layout row wrap class="mt-0">
        <v-flex md3 sm6 xs12 pa-3>
          <v-card dark color="#363636" min-height="145px">
            <v-card-title class="title card-title one-line">Payout Submitted</v-card-title>
            <v-card-text>
              <p class="ma-0 pa-0 h3">{{totalValues.submitted.actual}} / {{totalValues.submitted.total}}</p>
              <p class="ma-0 pa-0 subtitle-1">{{totalValues.submitted.percent}}%</p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <div class="row center-block">
        <div class="box" style="border:none">
          <!-- Box Body -->
          <div class="box-body">
            <!-- Filtering input -->
            <div class="row">
            <div class="col-xs-12">
              <v-card-title>
                <v-row style="justify-content:right;">
                  <!-- <v-col cols="12" sm="12" md="3" lg="3">
                    <v-autocomplete
                      v-model="searchFilters.campaignID"
                      item-value="id" 
                      item-text="name"
                      :items="campaignFilterLists"
                      label="Campaign Filter"
                      hide-details
                      outlined
                      dense
                      auto-select-first
                      @change="getAllCampaignPayouts"
                    ></v-autocomplete>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="3" lg="3" v-if="source == 'payout'">
                    <date-picker
                      className="input-field"
                      :options="{placeholder: 'Submission Date'}"
                      :date="searchFilters.submissionDate"
                      :status="subDateCal"
                      @changeDate="setSubmissionDateFilter"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3" v-if="source == 'payout'">
                    <date-picker
                      className="input-field"
                      :options="{placeholder: 'Due Date'}"
                      :date="searchFilters.dueDate"
                      :status="dueDateCal"
                      @changeDate="setDueDateFilter"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3">
                    <v-text-field
                      class="pt-0"
                      v-model="filter"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-spacer></v-spacer>
                <v-text-field
                  v-model="filter"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field> -->
              </v-card-title>
              <v-data-table
                ref="ReportPayoutListsTable"
                :headers="headers"
                :items="filteredItems"
                :search="filter"
                @current-items="currentItems"
                class="elevation-1"
              >
                <template v-slot:body="{items}">
                  <tbody>
                    <tr v-for="item in items" :key="item.name">
                      <td class="report-payout-handle-column">
                        <a :href="'https://www.tiktok.com/@' + item.handle" target="_blank" v-if="item.platform === 'tiktok'">
                        <img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.handle }}
                        </a>
                        <a target="_blank" v-bind:href="'https://youtube.com/' + item.handle" v-else-if="item.platform === 'youtube'"><v-icon color="#000000" small>mdi-youtube</v-icon> @{{ item.handle }}</a>
                        <a target="_blank" v-bind:href="'https://facebook.com/' + item.handle" v-else-if="item.platform === 'facebook'"><v-icon color="#000000" small>mdi-facebook</v-icon> @{{ item.handle }}</a>
                        <a target="_blank" :href="linkedInProfileUrl(item)" v-else-if="item.platform === 'linkedin'"><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{ item.handle }}</a>
                        <a target="_blank" :href="'https://x.com/' + item.handle" v-else-if="item.platform === 'twitter'"><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{ item.handle }}</a>
                        <a :href="'https://www.xiaohongshu.com/user/profile/' + item.xhsID" target="_blank" v-else-if="item.platform === 'xiaohongshu'"
                        ><img src="/static/img/xhs-black.png" width="20px" /> @{{ item.fullName || item.handle }}</a>
                        <a :href="'https://instagram.com/' + item.handle" target="_blank" v-else>
                        <v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.handle || item.instagram  }}
                        </a>
                      </td>
                      <td>
                        <div v-if="item.pending">
                          -
                        </div>
                        <div v-else>
                          {{ changeDateFormat(item.createdAt) }}
                        </div>
                      </td>
                      <td class="text-center">
                        <div v-if="item.pending">
                          -
                        </div>
                        <div v-else>
                          {{item.satisfaction_level_on_kobe}} / 5
                        </div>
                      </td>
                      <td class="text-center">
                        <div v-if="item.pending">
                          -
                        </div>
                        <div v-else>
                          {{item.satisfaction_level_on_advertiser}} / 5
                        </div>
                      </td>
                      <td class="read-more-text">
                        <div class="pending-text" v-if="item.pending">
                          -
                        </div>
                        <div v-else>
                          <div v-if="item.promotingProducts">
                            <read-more more-str="read more" :text="item.promotingProducts" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </div>
                      </td>
                      <td class="read-more-text">
                        <div class="pending-text" v-if="item.pending">
                          -
                        </div>
                        <div v-else>
                          <div v-if="item.improved">
                            <read-more more-str="read more" :text="item.improved" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </div>
                      </td>
                      <td class="read-more-text">
                        <div class="pending-text" v-if="item.pending">
                          -
                        </div>
                        <div v-else>
                          <div v-if="item.audienceEnjoyment">
                            <read-more more-str="read more" :text="item.audienceEnjoyment" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </div>
                      </td>
                      <td class="read-more-text">
                        <div class="pending-text" v-if="item.pending">
                          -
                        </div>
                        <div v-else>
                          <div v-if="item.otherCampaigns">
                            <read-more more-str="read more" :text="item.otherCampaigns" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="pending-text" v-if="item.pending">
                          <!-- <v-chip x-small color="warning">
                            Pending
                          </v-chip> -->
                          <v-btn
                            @click="copyFormLink(item)"
                            color="secondary"
                            v-bind="attrs"
                            v-on="on"
                            small
                            text
                          >
                            <v-icon small>mdi-content-copy</v-icon>
                            <span>Copy Stats Submit Form</span>
                          </v-btn>
                        </div>
                        <div v-else>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small color="secondary" class="ims-action"
                                :disabled="disableViewScreenshot(item)"
                                v-on="on"
                                @click="viewImages(item)"
                              >
                                <v-icon>mdi-image-multiple</v-icon>
                              </v-btn>
                            </template>
                            <span>View Attached Screenshots</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
                <template v-slot:no-results>
                  <v-alert color="error" icon="warning">
                    Your search for "{{ filter }}" found no results.
                  </v-alert>
                </template>
              </v-data-table>
            </div>
            </div>
          </div>
        </div>
      </div>
      <payout-screenshots-dialog
        v-model="viewScreenShotsDialog"
        :value="viewScreenShotsDialog"
        :imagesToView="imagesToView"
       />
       <v-snackbar
          v-model="copySucceeded"
        >
          Copied to Clipboard!
          <v-btn
            color="blue"
            text
            @click="copySucceeded = false"
          >
            Close
          </v-btn>
        </v-snackbar>
        <input type="hidden" id="copy-link" :value="formLink">
    </section>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment'
import config from '@/config'
import campaignConfig from '../config';
import utils from '@/utils';
import DatePicker from '@/components/scoped/custom/DatePicker'
import influencerAPIs from '../../Influencer/influencerAPIs'
import pairingAPIs from '../../Pairing/pairingAPIs';
import PayoutScreenshotsDialog from '../../Finance/PayoutScreenshotsDialog.vue'

export default {
  name: 'ReportPayoutLists',
  props: ['campaignID', 'refresh', 'source'],
  components: {
    PayoutScreenshotsDialog,
    DatePicker
  },
  data() {
    return {
      headers: [
        { value: 'handle', text: 'Handle', sortable: true, width: '210px', class: 'report-payout-handle-column', cellClass: 'report-payout-handle-column' },
        { value: 'createdAt', text: 'Submitted date', sortable: true },
        { value: 'satisfaction_level_on_kobe', text: 'Satisfication Level on Kobe', sortable: true },
        { value: 'satisfaction_level_on_advertiser', text: 'Satisfication Level on Client', sortable: true },
        { value: 'promotingProducts', text: 'What do you like most about this product/service you are promoting?', sortable: true },
        { value: 'improved', text: 'What are areas of improvement about this product/service that will be valuable feedback for them?', sortable: true },
        { value: 'audienceEnjoyment', text: 'What do you think your audience enjoyed about your content?', sortable: true },
        { value: 'otherCampaigns', text: 'What other campaigns would you want to work more on with us?', sortable: true },
        { value: 'action', text: 'Stats Submitted' }
      ],
      items: [],
      filteredItems: [],
      moneyouts: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      payoutViewDialog: false,
      payoutViewData: null,
      viewScreenShotsDialog: false,
      imagesToView: [],
      imageViewerDialog: false,
      activeImage: '',
      searchFilters: {},
      campaignFilterLists: [],
      subDateCal: false,
      dueDateCal: false,
      copySucceeded: false,
      formLink: '',
      totalValues: {
        submitted: {
          actual: 0,
          total: 0,
          percent: 0
        }
      }
    }
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    }
  },
  watch: {
    campaignID(value) {
      if (value) {
        this.searchFilters.campaignID = value
        this.getAllCampaignPayouts()
      }
    },
    refresh(value) {
      if (value) {
        this.resetFilters()
        this.getAllCampaignPayouts()
      }
    }
  },
  methods: {
    viewMedia(img) {
      this.activeImage = img
      this.imageViewerDialog = true
    },
    viewImages(item) {
      this.imagesToView = item
      this.viewScreenShotsDialog = true
    },
    buttonShow(type) {
      const roleAllow = config['userPermissions']['influencer'][type]
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    updateItems(newItems) {
      this.items = newItems
      this.totalRows = this.items.length
      this.setFilteredItems()
      this.filterbyDates()
      this.calcTotalSummary(this.filteredItems)
    },
    getAllCampaignPayouts() {
      influencerAPIs
        .getAllCampaignPayouts(this.searchFilters)
        .then(async (response) => {
          let displayItems = await this.getPairedInfluencers(this.searchFilters.campaignID)
          let campaignPayouts = response.data
          // For now, we only retrieve Instagram info
          campaignPayouts = campaignPayouts.map(element => {
            const elementPlatform = String(element.platform || '').toLowerCase()
            let resultData = {
              campaignName: element.campaignName,
              postID: element.postID,
              influencerID: element.influencerID,
              collaboration: element.collaboration || null,
              improved: element.improved || null,
              promotingProducts: element.promotingProducts || null,
              audienceEnjoyment: element.audienceEnjoyment || null,
              otherCampaigns: element.otherCampaigns || null,
              other_social_media_post_url: element.otherSocialMediaPostUrl,
              satisfaction_level_on_campaign: element.satisfactionLevel,
              satisfaction_level_on_kobe: element.kobeSatisfactionLevel,
              satisfaction_level_on_advertiser: element.advertiserSatisfactionLevel || 0,
              createdAt: element.createdAt,
              toMakePaymentAt: moment(element.createdAt).add(30, 'days').format(),
              payoutAmount: element.payoutAmount || '',
              // createdAt: moment(element.createdAt, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('DD-MM-YYYY HH:mm')
              images: element.images || [],
              posts: element.posts || [],
              stories: element.stories || [],
              deliverablePosts: element.deliverablePosts || []
            }
            if (element.linkedin || elementPlatform === 'linkedin') {
              resultData.handle = (element.linkedin && (element.linkedin.linkedinHandle || element.linkedin.handle)) ||
                element.linkedinHandle || element.handle ||
                (element.instagram && element.instagram.instagramHandle) || ''
              resultData.fullName = (element.linkedin && (element.linkedin.linkedinFullname || element.linkedin.fullName)) ||
                element.fullName || ''
              resultData.linkedin_post_url = element.linkedinPostURL || element.otherSocialMediaPostUrl || ''
              resultData.platform = 'linkedin'
            } else if (element.twitter || elementPlatform === 'twitter' || elementPlatform === 'x') {
              resultData.handle = (element.twitter && (element.twitter.twitterHandle || element.twitter.handle)) ||
                element.twitterHandle || element.userHandle || element.handle ||
                (element.instagram && element.instagram.instagramHandle) || ''
              resultData.fullName = (element.twitter && (element.twitter.twitterFullname || element.twitter.fullName)) ||
                element.fullName || ''
              resultData.twitter_post_url = element.twitterPostURL || element.otherSocialMediaPostUrl || ''
              resultData.platform = 'twitter'
            } else if (element.tiktok) {
              resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : ''
              resultData.fullName = element.tiktok ? element.tiktok.tiktokFullname : ''
              resultData.tiktok_post_url = element.tiktokPostURL
              resultData.platform = 'tiktok'
            } else {
              resultData.handle = element.instagram ? element.instagram.instagramHandle : ''
              resultData.fullName = element.instagram ? element.instagram.instagramFullname : ''
              resultData.instagram_post_url = element.instagramPostURL
              resultData.platform = 'instagram'
              resultData.xhsID = element.xhsID || ''
            }
            if (!resultData.handle) {
              if (element.handle) {
                resultData.handle = element.handle
                resultData.platform = element.platform || 'instagram'
                resultData.xhsID = element.xhsID || ''
              }
            }
            return Object.assign(
              {
                id: element.id,
                campaignID: element.campaignID,
                postID: element.postID
              },
              resultData
            )
          })
          displayItems = displayItems.map(item => {
            let matchPayout = campaignPayouts.find(c => (c.handle === item.handle && c.platform === item.platform) || (c.influencerID && c.influencerID === item.influencerID))
            if (matchPayout) {
              let handle = item.handle
              let platform = item.platform
              item = Object.assign({}, matchPayout)
              item.handle = handle
              item.platform = platform
            }
            return item
          })

          this.updateItems(displayItems)
          this.lastUpdate = response.lastUpdate
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    async getPairedInfluencers(campaignID) {
      let items = [];
      const pairingResp = await pairingAPIs.getPairedInfluencersByCampaign(campaignID)
      if (pairingResp) {
        for (let data of pairingResp) {
          let inf = this.beautifyPairingData(data);
          if (inf.pairingStatus === campaignConfig.pairingStatus.ACCEPTED) {
            items.push(inf);
          }
        }
      }
      return items
    },
    beautifyPairingData(data) {
      let inf = {}
      const influencerDetails = data.influencer_details;
      const rawPlatform = String(influencerDetails.platform || 'instagram').toLowerCase()
      const platform = rawPlatform === 'x' ? 'twitter' : rawPlatform
      inf.pairingID = data.id
      inf.influencerID = influencerDetails.influencerID || null
      inf.handle = platform === 'linkedin'
        ? (influencerDetails.linkedinHandle || influencerDetails.instagramHandle || influencerDetails.userHandle)
        : platform === 'twitter'
          ? (influencerDetails.twitterHandle || influencerDetails.userHandle ||
            (influencerDetails.twitter && influencerDetails.twitter.twitterHandle) || influencerDetails.instagramHandle)
          : influencerDetails.instagramHandle
      inf.platform = platform
      inf.xhsID = influencerDetails.xhsID || influencerDetails.instagramHandle
      inf.fullName = influencerDetails.fullName || ''
      inf.pairingStatus = data.pairing_details.status;
      inf.images = []
      inf.posts = []
      inf.stories = []
      inf.deliverablePosts = []
      inf.pending = true
      return inf
    },
    calDaysLeft: (date) => moment().to(date),
    changeDateFormat: (date) => moment(date).format('DD-MM-YYYY'),
    disableViewScreenshot(item) {
      return !item.images.length > 0 && !item.posts.length > 0 && !item.stories.length > 0 && !item.deliverablePosts.length > 0
    },
    filterbyDates() {
      if (this.searchFilters.submissionDate) {
        this.filteredItems = this.items.filter(item => item.createdAt && utils.func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === this.searchFilters.submissionDate)
      }
      if (this.searchFilters.dueDate) {
        let filterDueDate = moment(this.searchFilters.dueDate).subtract(30, 'days').format('YYYY-MM-DD')
        this.filteredItems = this.items.filter(item => item.createdAt && utils.func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === filterDueDate)
      }
      this.calcTotalSummary(this.filteredItems)
    },
    setSubmissionDateFilter(value) {
      this.searchFilters.submissionDate = value
      this.setFilteredItems()
      this.filterbyDates()
    },
    setDueDateFilter(value) {
      this.searchFilters.dueDate = value
      this.setFilteredItems()
      this.filterbyDates()
    },
    setFilteredItems() {
      this.filteredItems = Object.assign([], this.items)
    },
    resetFilters() {
      this.searchFilters.submissionDate = ''
      this.searchFilters.dueDate = ''
      this.filter = ''
    },
    resetTotalValues() {
      this.totalValues = {
        submitted: {
          actual: 0,
          total: 0,
          percent: 0
        }
      }
    },
    calcTotalSummary(items = []) {
      this.resetTotalValues()
      if (!items.length) {
        return;
      }
      let totalItems = items.length
      this.totalValues.submitted.total = totalItems
      let actualSubmitted = items.filter(f => !f.pending).length
      if (actualSubmitted) {
        this.totalValues.submitted.actual = actualSubmitted
        this.totalValues.submitted.percent = ((actualSubmitted / totalItems) * 100).toFixed(2)
      }
    },
    currentItems() {
      this.$nextTick(() => {
        this.calcTotalSummary(this.$refs.ReportPayoutListsTable.$children[0].filteredItems)
      });
    },
    copyFormLink(item) {
      this.copySucceeded = true
      const protocol = window.location.protocol
      const host = window.location.host
      this.formLink = `${protocol}//${host}/submit-post-payout?pairingID=${item.pairingID}`
      setTimeout(function() {
        item.linkCopied = utils.func.copyToClipboard('#copy-link')
      }, 100)
    },
    linkedInProfileUrl(item) {
      const explicitUrl = item.linkedinURL || item.linkedinUrl || item.linkedin_profile_url
      if (explicitUrl) return explicitUrl
      if (item.handle && /^https?:\/\//i.test(item.handle)) return item.handle
      return `https://www.linkedin.com/in/${item.handle || ''}`
    }
  },
  async created() {
    if (this.campaignID) {
      this.searchFilters.campaignID = this.campaignID
      this.getAllCampaignPayouts()
    }
  }
}
</script>
<style>
  .report-payout-list th.report-payout-handle-column,
  .report-payout-list td.report-payout-handle-column {
    min-width: 210px;
  }
  .report-payout-list .pending-text {
    text-align: center;
  }
  .report-payout-list .read-more-text p {
    margin-bottom: 0!important;
  }
  .sub-title {
    font-size: 22px!important;
    font-weight: 500;
  }
  .ims-action {
    margin: 6px 1px!important;
    min-width: 35px!important;
    padding: 0px!important;
  }
</style>



// WEBPACK FOOTER //
// ReportPayoutLists.vue?ac4ebfc4